<template>
  <el-card class="page-container">
    <h1 class="title-biaoti">周星活动排行礼物配置</h1>
    <div class="h_search">
      <label
        >周期：<el-select v-model="search.weekDuration" filterable>
          <el-option
            v-for="(item, ind) in durations"
            :key="ind"
            :label="item"
            :value="item"
          ></el-option> </el-select
      ></label>
      <label
        >是否有效：<el-select v-model="search.valid">
          <el-option label="有效" :value="1"></el-option>
          <el-option label="无效" :value="0"></el-option> </el-select
      ></label>
      <el-button type="primary" @click="query" :loading="loading">
        查询
      </el-button>
      <el-button type="warning" @click="operate(1)">
        新增
      </el-button>
    </div>
    <el-table
      :data="list"
      style="width: 100%"
      v-loading="loading"
      stripe
      border
    >
      <el-table-column prop="weekDuration" fixed label="周期">
      </el-table-column>
      <el-table-column prop="giftId" label="礼物id"> </el-table-column>
      <el-table-column prop="score" label="单位礼物得分"> </el-table-column>
      <el-table-column prop="weight" label="排序权重"> </el-table-column>
      <el-table-column label="是否有效">
        <template slot-scope="scope">
          {{ scope.row.valid == 1 ? '有效' : '无效' }}
        </template>
      </el-table-column>
      <el-table-column prop="ctime" label="创建时间"> </el-table-column>
      <el-table-column prop="mtime" label="修改时间"> </el-table-column>
      <el-table-column prop="operator" label="操作人"> </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button size="mini" @click="operate(2, scope.row)">修改</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-dialog
      :title="isAdd ? '新 增' : '编 辑'"
      :visible.sync="dialog"
      width="50%"
      :before-close="handleClose"
    >
      <div class="h_item" v-if="isAdd">
        <span>礼物日期范围：</span
        ><el-date-picker
          v-model="data.time"
          type="daterange"
          align="right"
          unlink-panels
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          value-format="yyyy-MM-dd"
        >
        </el-date-picker>
      </div>
      <div class="h_item">
        <span>礼物ID：</span
        ><el-input type="text" v-model="data.giftId"></el-input>
      </div>
      <div class="h_item">
        <span>分数：</span
        ><el-input type="text" v-model="data.score"></el-input>
      </div>
      <div class="h_item">
        <span>权重：</span
        ><el-input type="text" v-model="data.weight"></el-input>
      </div>
      <div class="h_item">
        <span>是否有效：</span>
        <el-switch
          v-model="data.valid"
          active-text="有效"
          inactive-text="无效"
          :active-value="1"
          :inactive-value="0"
        ></el-switch>
      </div>
      <div class="h_item">
        <el-button type="primary" @click="operate(3)" v-if="isAdd"
          >新增</el-button
        >
        <el-button type="primary" @click="operate(4)" v-else>编辑</el-button>
        <el-button type="warning" @click="handleClose">取消</el-button>
      </div>
    </el-dialog>
  </el-card>
</template>
<script>
export default {
  data() {
    return {
      durations: [],
      list: [],
      loading: false,
      isAdd: true,
      dialog: false,
      data: {
        id: '',
        activityType: '18',
        beginDate: '',
        endDate: '',
        time: [],
        giftId: '',
        score: '',
        weight: '',
        valid: 1,
        operator: this.$store.getters.username
      },
      search: {
        weekDuration: '',
        activityType: '18',
        valid: 1
      }
    }
  },
  async created() {
    await this.getDurations()
    await this.query()
  },
  methods: {
    async getDurations() {
      const { data: res } = await this.$axios.get(
        this.$store.getters.path.weekStar_durations +
          '?username=' +
          this.$store.getters.username +
          '&token=' +
          this.$store.getters.token,
        { params: {} }
      )
      if (res.code !== 0) return
      this.durations = res.data
      this.search.weekDuration = res.data[0]
    },
    async query() {
      this.loading = true
      const { data: res } = await this.$axios.get(
        this.$store.getters.path.weekStar_list +
          '?username=' +
          this.$store.getters.username +
          '&token=' +
          this.$store.getters.token,
        { params: this.search }
      )
      this.loading = false
      if (res.code !== 0) return this.message.error(res.msg)
      this.list = res.data
    },
    async operate(type, row) {
      if (type == 1) {
        this.dialog = true
        this.isAdd = true
      } else if (type == 2) {
        this.dialog = true
        this.isAdd = false
        this.data = { ...row }
      } else if (type == 3 || type == 4) {
        let url, data
        if (type == 3) {
          url =
            this.$store.getters.path.weekStar_create +
            '?username=' +
            this.$store.getters.username +
            '&token=' +
            this.$store.getters.token
          this.data.id = ''
          this.data.beginDate = this.data.time[0]
          this.data.endDate = this.data.time[1]
          data = {
            ...this.data
          }
        } else {
          url =
            this.$store.getters.path.weekStar_update +
            '?username=' +
            this.$store.getters.username +
            '&token=' +
            this.$store.getters.token
          data = {
            id: this.data.id,
            giftId: this.data.giftId,
            score: this.data.score,
            weight: this.data.weight,
            operator: this.$store.getters.username,
            valid: this.data.valid
          }
        }

        const { data: res } = await this.$axios.post(url, data)
        if (res.code != 0) return this.$message.error(res.msg)
        this.handleClose()
        this.query()
        this.getDurations()
      }
    },
    handleClose() {
      this.data = {
        id: '',
        activityType: '18',
        beginDate: '',
        endDate: '',
        time: [],
        giftId: '',
        score: '',
        weight: '',
        valid: 1,
        operator: this.$store.getters.username
      }
      this.dialog = false
    }
  }
}
</script>
<style lang="scss" scoped></style>
